import D3StarRating from './d3StarRating'
export default D3StarRating
